import NavBarD7 from './NavBarD7';

export default NavBarD7;
